// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._154iidpf{top:0}\n._18m91wug{overflow-y:auto}\n._1bsb1osq{width:100%}\n._1ltvidpf{left:0}\n._1reo15vq{overflow-x:hidden}\n._kqswstnw{position:absolute}\n._n3tdu2gc{padding-bottom:var(--ds-space-100,8px)}\n._1hvw1o36:focus{outline-width:medium}\n._49pcglyw:focus{outline-style:none}\n._nt751r31:focus{outline-color:currentColor}", ""]);
// Exports
module.exports = exports;
